var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgActivityCall = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 36 36",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13.156 16.91a13.6 13.6 0 0 0 5.931 5.93l1.98-1.98a.9.9 0 0 1 .918-.225c1.008.333 2.088.513 3.213.513a.9.9 0 0 1 .9.9v3.15a.9.9 0 0 1-.9.9 15.3 15.3 0 0 1-15.3-15.3.9.9 0 0 1 .9-.9h3.15a.9.9 0 0 1 .9.9c0 1.125.18 2.205.513 3.213a.9.9 0 0 1-.225.918l-1.98 1.98Z"
})));
export default SvgActivityCall;